var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-content", staticStyle: { padding: "0" } },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "轮播图广告", name: "carouselAd" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeTab === "carouselAd"
                    ? _c("CarouselAdTab")
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "首页悬浮图标", name: "floatingIcon" } },
            [
              _c(
                "keep-alive",
                [
                  _vm.activeTab === "floatingIcon"
                    ? _c("FloatingIconTab")
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }